const MODALS = {
  ADMIN_CLAUSE: 'AdminClauseModal',
  ADMIN_TAG: 'AdminTagModal',
  ADMIN_CREATE_TEMPLATE: 'AdminCreateTemplateModal',
};

export default MODALS;
